var map = {
	"./3-ani.svg": "44ba",
	"./30-zile.svg": "8771",
	"./60-zile.svg": "19c4",
	"./camera.svg": "d24a",
	"./contact.svg": "ab17",
	"./emergency.svg": "eca1",
	"./law.svg": "fe24",
	"./search.svg": "f919",
	"./strategy.svg": "0096",
	"./todo.svg": "618e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0075";